import type {
  MeResponse,
  TermsAcceptanceResponse,
} from "@server/types/responseTypes";
import { apiGet, apiPatch, createApiUrl } from "@/utils/apiUtils";

export const fetchAuthedUser = async () => {
  const res = await apiGet<MeResponse>(createApiUrl("me"));
  return res.data;
};

/** Persists the authenticated user's required legal consent. */
export const acceptTerms = async () => {
  const res = await apiPatch<TermsAcceptanceResponse>(
    createApiUrl("me", "terms-acceptance"),
    { accepted: true },
  );
  return res.data;
};
